/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { Button, SecurityHelper } from 'sarsaparilla';
import { useNavigate } from 'react-router';
import { authModalActions } from 'shared-ui/auth/redux';
import { PERMIT, SEASON } from '../propTypes';

function ClearCreekSidebar({ permit, seasons, account }) {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [waitingForUserAccount, setWaitingForUserAccount] = useState(false);

    const onClick = () => {
        const loggedin = SecurityHelper.isLoggedIn();
        if (!loggedin) {
            setWaitingForUserAccount(true);
            dispatch(authModalActions.openLoginModal());
            return;
        }
        navigate(`/vehiclepermits/${permit.id}/registration`);
    };

    useEffect(() => {
        if (SecurityHelper.isLoggedIn() && waitingForUserAccount && account) {
            setWaitingForUserAccount(false);

            onClick();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [waitingForUserAccount, account]);

    return (
        <>
            <p>
                Before you get started, please note that you may need multiple permits to
                access areas within this facility.
            </p>
            <Button
                onClick={onClick}
                size="lg"
                isDisabled={!seasons?.length}
                shouldFitContainer
            >
                Get Permits
            </Button>
        </>
    );
}

ClearCreekSidebar.propTypes = {
    permit: PERMIT.isRequired,
    seasons: PropTypes.arrayOf(SEASON),
    account: PropTypes.object,
};

export default ClearCreekSidebar;
